import { ADDON_UPDATE_STEP, ADDONS, ADDON_ESTIMATE, ADDON_REQ_SENT, ADDON_REQ_FAILED, ADDON_LOADING } from './AddonActions';

import { COUNTRIES } from '../../util/countries';

const INITIAL_STATE = {
  countries: COUNTRIES,
  sent: false,
  addons: {},
  model: {},
  estimation: {},
  error: undefined,
  paymentLoading: false,
};

const AddonReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADDON_UPDATE_STEP:
      return {
        ...state,
        model: action.model,
      };
    case ADDONS:
      return {
        ...state,
        addons: action.addons,
        paymentLoading: false,
      };
    case ADDON_ESTIMATE:
      return {
        ...state,
        estimation: action.data,
        sent: false,
      };
    case ADDON_REQ_SENT:
      return {
        ...state,
        sent: true,
        error: undefined,
        paymentLoading: false,
      };
    case ADDON_REQ_FAILED:
      return {
        ...state,
        error: action.error,
        sent: true,
        paymentLoading: false,
      };
    case ADDON_LOADING: {
      return {
        ...state,
        paymentLoading: action.value,
      };
    }
  }

  return state;
};

export default AddonReducer;
